/* global axios */
import ApiClient from './ApiClient';

class MangoAPI extends ApiClient {
  constructor() {
    super('mango', { accountScoped: true });
  }

  // Current agent's softphone credentials (bridge audio mode).
  sipCredentials() {
    return axios.get(`${this.url}/sip_credentials`);
  }

  // Current agent's own mapping — used by the dialpad.
  myLine() {
    return axios.get(`${this.url}/my_line`);
  }

  // Wizard: check credentials before the channel exists.
  validateKey(apiKey, apiSalt) {
    return axios.post(`${this.url}/validate_key`, {
      api_key: apiKey,
      api_salt: apiSalt,
    });
  }

  diagnostics(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/diagnostics`);
  }

  // Auto-setup: read the PBX directory and map agents by email.
  setup(inboxId) {
    return axios.post(`${this.url}/inboxes/${inboxId}/setup`);
  }

  // PBX employees for the agent-mapping UI.
  directory(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/directory`);
  }

  agents(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/agents`);
  }

  updateAgent(inboxId, payload) {
    return axios.post(`${this.url}/inboxes/${inboxId}/agents`, payload);
  }

  // Hand an agent the SIP line for the browser softphone.
  provisionSip(inboxId, userId) {
    return axios.post(`${this.url}/inboxes/${inboxId}/agents/${userId}/sip`);
  }

  // Colleagues a live call can be handed to (mapped to a PBX employee and
  // currently taking calls).
  transferTargets(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/transfer_targets`);
  }

  // Transfer from the softphone: the server resolves which call is ours.
  transferActiveCall(inboxId, toNumber) {
    return axios.post(`${this.url}/inboxes/${inboxId}/active_call/transfer`, {
      to_number: toNumber,
    });
  }

  // Free the line but keep the employee mapping, so it can go to someone else.
  releaseSip(inboxId, userId) {
    return axios.delete(`${this.url}/inboxes/${inboxId}/agents/${userId}/sip`);
  }

  deleteAgent(inboxId, userId) {
    return axios.delete(`${this.url}/inboxes/${inboxId}/agents/${userId}`);
  }

  webhookStatus(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/webhook_status`);
  }

  // Dialpad: call a number that has no contact behind it yet.
  dial(inboxId, number) {
    return axios.post(`${this.url}/inboxes/${inboxId}/dial`, { number });
  }

  // Live-call control: hangup / hold / record / transfer.
  callCommand(inboxId, callId, command, payload = {}) {
    return axios.post(
      `${this.url}/inboxes/${inboxId}/calls/${callId}/${command}`,
      payload
    );
  }
}

export default new MangoAPI();
